import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '../bf-auth-service';
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { BF_AUTH_CONFIG } from '../bf-auth-config';
import { BfAuthJwtHelper } from '../bf-auth-jwt-helper';
import { BfAuthService } from '../bf-auth-service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../bf-auth-config/bf-auth.config";
var BfAuthGuard = /** @class */ (function () {
    function BfAuthGuard(router, bfAuthConfig) {
        this.router = router;
        this.bfAuthConfig = bfAuthConfig;
    }
    BfAuthGuard.prototype.canActivate = function () {
        var token = localStorage.getItem('id_token');
        var isExpired = BfAuthJwtHelper.isTokenExpired(token);
        if (isExpired) {
            this.router.navigate([this.bfAuthConfig.LoginPageURL]);
            return false;
        }
        else {
            return true;
        }
    };
    BfAuthGuard.ngInjectableDef = i0.defineInjectable({ factory: function BfAuthGuard_Factory() { return new BfAuthGuard(i0.inject(i1.Router), i0.inject(i2.BF_AUTH_CONFIG)); }, token: BfAuthGuard, providedIn: "root" });
    BfAuthGuard = __decorate([ __param(1, Inject(BF_AUTH_CONFIG)),
        __metadata("design:paramtypes", [Router, Object])
    ], BfAuthGuard);
BfAuthGuard.ɵfac = function BfAuthGuard_Factory(t) { return new (t || BfAuthGuard)(ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(BF_AUTH_CONFIG)); };
BfAuthGuard.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BfAuthGuard, factory: function (t) { return BfAuthGuard.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BfAuthGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: Object, decorators: [{
                type: Inject,
                args: [BF_AUTH_CONFIG]
            }] }]; }, null); })();
    return BfAuthGuard;
}());
export { BfAuthGuard };
var BfAuthPermissionsGuard = /** @class */ (function () {
    function BfAuthPermissionsGuard(router, authService) {
        this.router = router;
        this.authService = authService;
    }
    BfAuthPermissionsGuard.prototype.canActivate = function (routeSnapShot) {
        if (routeSnapShot.data && routeSnapShot.data['Application'] && routeSnapShot.data['Permissions']) {
            return this.authService.hasPermissions(routeSnapShot.data['Permissions'], routeSnapShot.data['Application']);
        }
        return true;
    };
    BfAuthPermissionsGuard = __decorate([ __metadata("design:paramtypes", [Router,
            BfAuthService])
    ], BfAuthPermissionsGuard);
BfAuthPermissionsGuard.ɵfac = function BfAuthPermissionsGuard_Factory(t) { return new (t || BfAuthPermissionsGuard)(ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(ɵngcc2.BfAuthService)); };
BfAuthPermissionsGuard.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BfAuthPermissionsGuard, factory: function (t) { return BfAuthPermissionsGuard.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BfAuthPermissionsGuard, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.Router }, { type: ɵngcc2.BfAuthService }]; }, null); })();
    return BfAuthPermissionsGuard;
}());
export { BfAuthPermissionsGuard };

